<div class="row">
  <div class="col-md-12">
    <br>
    <div class="titulo">
      Mantenedor Certificaciones
    </div>
  </div>

  <div class="col-md-12">
    <br>

    <div class="sub-titulo d-flex align-items-center justify-content-between">
      <span class="linea">
        Listado de Certificaciones
      </span>

      <div class="d-flex align-items-center">
        <!-- Selector de clientes -->
        <select
          class="form-control mr-2"
          style="min-width: 260px;"
          [(ngModel)]="selectedCustomerId"
          (ngModelChange)="applyFilter()"
        >
          <option [ngValue]="null">Todos los clientes</option>
          <option *ngFor="let c of listCustomers" [ngValue]="c.cus_id">
            {{ c.cus_name }}
          </option>
        </select>

        <!-- Botón -->
        <button
          type="button"
          class="btn btn-outline-primary botonListar"
          data-toggle="modal"
          data-target="#crearCertificacion"
          (click)="openCrearCert()"
        >
          Agregar Certificación
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="isLoading" class="text-center my-4">
    <div class="loader">
      <div class="loader__figure"></div>
      <p class="loader__label">Medis</p>
    </div>
  </div>

  <div *ngIf="isLoading == false" class="col-md-12">
    <br>
    <table class="table table-bordered">
      <thead style="font-family: Mulish; font-style: normal; font-weight: bold; font-size: 20px; color: #171994; text-align: center; background-color: #e6f0ff;">
        <tr>
          <th>#</th>
          <th>Cliente</th>
          <th>Título</th>
          <th>Imagen</th>
          <th>Estado</th>
          <th>Acciones</th>
        </tr>
      </thead>

      <tbody style="background-color: white; font-family: Mulish; font-size: 16px; color: #3F3F3F; text-align: center;">
        <tr class="ng-star-inserted" *ngFor="let cert of certsFiltered; let i = index">
          <td>{{ cert.cer_id }}</td>
          <td>{{ cert.cus_name ? cert.cus_name : 'Global' }}</td>
          <td>{{ cert.title }}</td>
          <td>
            <img *ngIf="cert.image_url" class="svgItem" style="width: 70px;" [src]="URL_DOCS + cert.image_url | safeUrl" />
            <span *ngIf="!cert.image_url">Sin Imagen</span>
          </td>
          <td>{{ cert.is_active ? 'Activo' : 'Desactivado' }}</td>

          <td>
            <div class="row justify-content-center m-0">
              <div class="col-12 p-0">
                <span
                  data-toggle="modal"
                  data-target="#editarCertificacion"
                  style="cursor: pointer;"
                  (click)="clickCert(cert)"
                >
                  <mat-icon
                    role="img"
                    class="mat-icon notranslate material-icons mat-icon-no-color"
                    style="color: #316AD8;"
                    aria-hidden="true"
                    data-mat-icon-type="font"
                  >
                    manage_search
                  </mat-icon>
                </span>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div *ngIf="isLoading" class="overlay-cargando">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Cargando...</span>
    </div>
  </div>
</div>


<!-- ========================= -->
<!-- modal Crear Certificación -->
<!-- ========================= -->
<div class="modal fade" id="crearCertificacion" aria-labelledby="crearCertificacionLabel" aria-hidden="true" #crearCertificacion>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-body">
        <div class="estiloBodyModal">
          <p class="tituloModal" style="margin: 0%; width: auto;">Crear nueva Certificación</p>
          <hr class="estiloHrModal">
          <br>

          <div class="divBodyModal row">
            <div class="col-4 mt-3">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="chkCertIsActive"
                  [(ngModel)]="nuevaCert.is_active"
                >
                <label class="custom-control-label letraNormalModal" for="chkCertIsActive">
                  <strong>Activar</strong>
                </label>
              </div>
            </div>

            <!-- Global + Cliente -->
            <div class="col-3 mt-3">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="chkCertGlobal"
                  [(ngModel)]="nuevaCert.is_global"
                  [disabled]="!!nuevaCert.is_tranversal"
                  (change)="onToggleGlobalCrearCert()"
                />
                <label class="custom-control-label letraNormalModal" for="chkCertGlobal">
                  <strong>Global (para todos los clientes)</strong>
                </label>
              </div>
            </div>

            <div class="col-9 mt-2">
              <p class="letraNormalModal"><strong>Cliente:</strong></p>
              <select
                class="form-control"
                [(ngModel)]="nuevaCert.b2b_id_customer"
                [disabled]="nuevaCert.is_global || nuevaCert.is_tranversal"
                [ngClass]="{'is-invalid': erroresCert.b2b_id_customer}"
              >
                <option [ngValue]="null">Seleccione cliente...</option>
                <option *ngFor="let c of listCustomers" [ngValue]="c.cus_id">
                  {{ c.cus_name }}
                </option>
              </select>

              <div *ngIf="erroresCert.b2b_id_customer" class="invalid-feedback">
                Debes seleccionar un cliente si la certificación no es global.
              </div>

              <small *ngIf="nuevaCert.is_global" class="text-muted">
                Al ser global, no se asocia a un cliente específico.
              </small>
            </div>
          </div>

          <hr class="estiloHrModal">

          <div class="divBodyModal row">
            <!-- Título -->
            <div class="col-8">
              <p class="letraNormalModal"><strong>Título:</strong></p>
              <input
                class="form-control camposModalAgregar"
                type="text"
                placeholder="Título"
                [(ngModel)]="nuevaCert.title"
                maxlength="50"
                (input)="nuevaCert.title = (nuevaCert.title || '').slice(0, 50)"
                [ngClass]="{'is-invalid': erroresCert.title}"
              >
              <small class="text-muted">
                {{ (nuevaCert.title?.length || 0) }} / 50
              </small>
              <div *ngIf="erroresCert.title" class="invalid-feedback">
                El título es obligatorio.
              </div>
            </div>

            <!-- Prioridad -->
            <div class="col-4">
              <p class="letraNormalModal"><strong>Orden / Prioridad:</strong></p>
              <select class="form-control" [(ngModel)]="nuevaCert.priority">
                <option *ngFor="let num of numeros" [value]="num">{{ num }}</option>
              </select>
              <small class="text-muted">Menor prioridad = aparece primero.</small>
            </div>

            <!-- Descripción -->
            <div class="col-12 mt-3">
              <p class="letraNormalModal"><strong>Descripción:</strong></p>
              <textarea
                class="form-control camposModalAgregar"
                placeholder="Descripción"
                [(ngModel)]="nuevaCert.description"
                [ngClass]="{'is-invalid': erroresCert.description}"
                rows="3"
                maxlength="220"
                (input)="nuevaCert.description = (nuevaCert.description || '').slice(0, 220)"
              ></textarea>
              <small class="text-muted">
                {{ (nuevaCert.description?.length || 0) }} / 220
              </small>
              <div *ngIf="erroresCert.description" class="invalid-feedback">
                La descripción es obligatoria.
              </div>
            </div>

            <!-- Link -->
            <!--
            <div class="col-12 col-md-8 mt-3">
              <p class="letraNormalModal"><strong>Link:</strong></p>
              <input
                class="form-control camposModalAgregar"
                type="text"
                placeholder=""
                [(ngModel)]="nuevaCert.link_url"
                [ngClass]="{'is-invalid': erroresCert.link_url}"
              >
            </div>

            <div class="col-12 col-md-4 mt-3">
              <p class="letraNormalModal"><strong>Abrir en:</strong></p>
              <select class="form-control" [(ngModel)]="nuevaCert.link_target">
                <option value="_blank">Nueva ventana</option>
                <option value="_self">Misma ventana</option>
              </select>
            </div>
            -->

            <!-- Imagen -->
            <div class="col-12 mt-3">
              <p class="letraNormalModal"><strong>Imagen:</strong></p>
              <input
                class="form-control camposModalAgregar"
                type="file"
                accept="image/*"
                (change)="onCertImageSelected($event)"
                [ngClass]="{'is-invalid': erroresCert.image_file}"
              >
              <div *ngIf="erroresCert.image_file" class="invalid-feedback">
                Debes seleccionar una imagen.
              </div>

              <div class="mt-2" *ngIf="certImagePreview">
                <p class="letraNormalModal"><strong>Vista previa:</strong></p>
                <img [src]="certImagePreview" style="max-width: 100%; max-height: 180px; border-radius: 8px;">
                <br><br>
                <button class="btn btn-outline-danger" (click)="clearSelectedCertImage()">Quitar imagen seleccionada</button>
              </div>

              <small class="text-muted">Formatos recomendados: JPG/PNG. Tamaño sugerido: &lt; 2MB.</small>
            </div>

          </div>

          <hr class="estiloHrModal">

          <div class="container-fluid" style="padding: 10px 10px; align-items:center; text-align: center;">
            <button
              type="button"
              class="primary buttonStyleSecondary"
              (click)="saveCert('insert')"
              [disabled]="isLoading"
            >
              <span *ngIf="!isLoading">Guardar</span>
              <span *ngIf="isLoading">Guardando...</span>
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isLoading && modalActivo === 'crear'" class="overlay-modal">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Cargando...</span>
    </div>
  </div>
</div>
<!-- /modal Crear Certificación -->


<!-- =========================== -->
<!-- modal Ver/Editar Certificación -->
<!-- =========================== -->
<div class="modal fade" id="editarCertificacion" aria-labelledby="editarCertificacionLabel" aria-hidden="true" #editarCertificacion>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-body">
        <div class="estiloBodyModal">
          <p class="tituloModal" style="margin: 0%; width: auto;">Ver / Editar Certificación</p>
          <hr class="estiloHrModal">
          <br>

          <div class="divBodyModal row">
            <!-- Checks -->
            <div class="col-4 mt-3">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="chkEditCertIsActive"
                  [(ngModel)]="certSelected.is_active"
                  [disabled]="!isEdit"
                >
                <label class="custom-control-label letraNormalModal" for="chkEditCertIsActive">
                  <strong>Activar</strong>
                </label>
              </div>
            </div>

            <div class="col-3 mt-3">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="chkEditCertGlobal"
                  [(ngModel)]="certSelected.is_global"
                  [disabled]="!isEdit || !!certSelected.is_tranversal"
                  (change)="onToggleGlobalEditarCert()"
                />
                <label class="custom-control-label letraNormalModal" for="chkEditCertGlobal">
                  <strong>Global (para todos los clientes)</strong>
                </label>
              </div>
            </div>

            <!-- Cliente -->
            <div class="col-9 mt-2">
              <p class="letraNormalModal"><strong>Cliente:</strong></p>
              <select
                class="form-control"
                [(ngModel)]="certSelected.b2b_id_customer"
                [disabled]="(certSelected.is_global || certSelected.is_tranversal) || !isEdit"
                [ngClass]="{'is-invalid': erroresCert.b2b_id_customer}"
              >
                <option [ngValue]="null">Seleccione cliente...</option>
                <option *ngFor="let c of listCustomers" [ngValue]="c.cus_id">
                  {{ c.cus_name }}
                </option>
              </select>

              <div *ngIf="erroresCert.b2b_id_customer" class="invalid-feedback">
                Debes seleccionar un cliente si la certificación no es global.
              </div>

              <small *ngIf="certSelected.is_global" class="text-muted">
                Al ser global, no se asocia a un cliente específico.
              </small>
            </div>
          </div>

          <hr class="estiloHrModal">

          <div class="divBodyModal row">
            <!-- Título -->
            <div class="col-8">
              <p class="letraNormalModal"><strong>Título:</strong></p>
              <input
                class="form-control camposModalAgregar"
                type="text"
                placeholder="Título"
                [(ngModel)]="certSelected.title"
                maxlength="50"
                (input)="certSelected.title = (certSelected.title || '').slice(0, 50)"
                [disabled]="!isEdit"
                [ngClass]="{'is-invalid': erroresCert.title}"
              >
              <small class="text-muted">
                {{ (certSelected.title?.length || 0) }} / 50
              </small>
              <div *ngIf="erroresCert.title" class="invalid-feedback">
                El título es obligatorio.
              </div>
            </div>

            <!-- Prioridad -->
            <div class="col-4">
              <p class="letraNormalModal"><strong>Orden / Prioridad:</strong></p>
              <select class="form-control" [(ngModel)]="certSelected.priority" [disabled]="!isEdit">
                <option *ngFor="let num of numeros" [value]="num">{{ num }}</option>
              </select>
              <small class="text-muted">Menor prioridad = aparece primero.</small>
            </div>

            <!-- Descripción -->
            <div class="col-12 mt-3">
              <p class="letraNormalModal"><strong>Descripción:</strong></p>
              <textarea
                class="form-control camposModalAgregar"
                placeholder="Descripción"
                [(ngModel)]="certSelected.description"
                [disabled]="!isEdit"
                [ngClass]="{'is-invalid': erroresCert.description}"
                rows="3"
                maxlength="220"
                (input)="certSelected.description = (certSelected.description || '').slice(0, 220)"
              ></textarea>
              <small class="text-muted">
                {{ (certSelected.description?.length || 0) }} / 220
              </small>
              <div *ngIf="erroresCert.description" class="invalid-feedback">
                La descripción es obligatoria.
              </div>
            </div>

            <!-- Imagen actual + reemplazo -->
            <div class="col-12 mt-3">
              <p class="letraNormalModal"><strong>Imagen:</strong></p>

              <div *ngIf="certSelected.image_url" class="mt-2">
                <p class="letraNormalModal"><strong>Imagen actual:</strong></p>
                <img [src]="URL_DOCS + certSelected.image_url" style="max-width: 100%; max-height: 180px; border-radius: 8px;">
              </div>

              <input
                class="form-control camposModalAgregar mt-2"
                type="file"
                accept="image/*"
                (change)="onCertImageSelected($event)"
                [disabled]="!isEdit"
                [ngClass]="{'is-invalid': erroresCert.image_file}"
              >

              <div *ngIf="erroresCert.image_file" class="invalid-feedback">
                Debes seleccionar una imagen válida.
              </div>

              <div class="mt-2" *ngIf="certImagePreview">
                <p class="letraNormalModal"><strong>Vista previa (nueva imagen):</strong></p>
                <img [src]="certImagePreview" style="max-width: 100%; max-height: 180px; border-radius: 8px;">
                <br><br>
                <button class="btn btn-outline-danger" (click)="clearSelectedCertImage()" [disabled]="!isEdit">
                  Quitar imagen seleccionada
                </button>
              </div>

              <small class="text-muted">Formatos recomendados: JPG/PNG. Tamaño sugerido: &lt; 2MB.</small>
            </div>

          </div>

          <hr class="estiloHrModal">

          <div class="container-fluid" style="padding: 10px 10px; align-items:center; text-align: center;">
            <button
              *ngIf="!isEdit"
              type="button"
              class="primary buttonStyleSecondary"
              (click)="isEdit = true"
              [disabled]="isLoading"
            >
              Editar
            </button>

            <button
              *ngIf="isEdit"
              type="button"
              class="primary buttonStyleSecondary"
              (click)="saveCert('update')"
              [disabled]="isLoading"
            >
              <span *ngIf="!isLoading">Guardar cambios</span>
              <span *ngIf="isLoading">Guardando...</span>
            </button>

            <button
              type="button"
              class="boton-accion colorLetraVolver ml-2"
              data-dismiss="modal"
              aria-label="Close"
              [disabled]="isLoading"
              (click)="cancelEditCert('update')"
            >
              Cerrar
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isLoading && modalActivo === 'editar'" class="overlay-modal">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Cargando...</span>
    </div>
  </div>
</div>
<!-- /modal Ver/Editar Certificación -->
